import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import type { FieldRendererProps } from "./index";

export function DatetimeField({ label, required, properties, disabled }: FieldRendererProps) {
  return (
    <div className="space-y-2">
      <Label>
        {label}
        {required && <span className="ml-1 text-destructive">*</span>}
      </Label>
      <Input type="datetime-local" disabled={disabled} placeholder={properties.placeholder ?? ""} />
    </div>
  );
}
